import type { DefaultValues } from 'react-hook-form'

import type { Strategies } from '@fortem-monorepo/web-sdk'

import type { UpdateStrategyValues } from './UpdateStrategyForm.schema'

const toBooleanChoice = (value: boolean | null): 'true' | 'false' | undefined => {
  if (value === null) {
    return undefined
  }

  return value ? 'true' : 'false'
}

export const toUpdateStrategyValues = (strategy: Strategies.Strategy): DefaultValues<UpdateStrategyValues> => ({
  strategy_name: strategy.strategy_name,
  strategy_type: strategy.strategy_type,
  is_internal: toBooleanChoice(strategy.is_internal),
  active: toBooleanChoice(strategy.active),
})
